import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { QuoteDetailDto } from "../../../types/dto/quote-detail-dto";
import { CustomCell } from "../CustomCell";

interface Props {
  data: QuoteDetailDto;
  index: number;
  startIndex: number;
}

export const PartnerDetailQuoteRow: React.FC<Props> = ({
  data,
  index,
  startIndex,
}) => {
  const navigate = useNavigate();
  const item = data;

  const handleClick = () => {
    window.open(`/quotes/details/${data.id}`, "_blank");
  };

  return (
    <Table.Row key={item.id} className="bg-primary-white">
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {startIndex - index}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="cursor-pointer" onClick={handleClick}>
        <CustomCell>
          <Body14Underline className="text-semantic-text-body">
            {`${data.cartItems[0]?.name}`}{" "}
            {data.cartItems.length > 1 && `외 ${data.cartItems.length - 1}`}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatCommasNumber(data.totalPriceSum)}원
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {data.ordererName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {/* 중앙관리형 IOT 시스템 공사 */}
            {data.constructionName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDD(data.createdAt)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
